import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function CommissionBlock(props) {
  const { backgroundColor, icon, label, value, textColor, tooltip } = props;

  useEffect(() => {
    if (typeof $ === 'undefined') return;

    if (tooltip) {
      $('[data-toggle="m-popover"]').each(function initPopover() {
        const el = $(this);
        const skin = el.data('skin')
          ? `m-popover--skin-${el.data('skin')}`
          : '';

        el.popover({
          trigger: 'hover',
          template: `\
            <div class='m-popover ${skin} popover' role='tooltip'>\
                <div class='arrow'></div>\
                <h3 class='popover-header'></h3>\
                <div class='popover-body'></div>\
            </div>`,
        });
      });
    }
  }, [tooltip]);

  return (
    <div
      className="commission-block"
      style={{ backgroundColor }}
      data-toggle={tooltip ? 'm-popover' : undefined}
      data-content={tooltip ? tooltip.content : ''}
      data-original-title={tooltip ? tooltip.title : ''}
    >
      <div className="information">
        {icon ? <div className="icon-container">{icon}</div> : null}
        <p className="blockLabel">{label}</p>
      </div>
      <p className="blockValue" style={{ color: textColor }}>
        {value}
      </p>
    </div>
  );
}

CommissionBlock.propTypes = {
  backgroundColor: PropTypes.string,
  icon: PropTypes.node,
  textColor: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  tooltip: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),
};

CommissionBlock.defaultProps = {
  backgroundColor: '#1BADFF26',
  textColor: '#1BADFF',
  icon: null,
  label: '',
  value: '',
  tooltip: null,
};

export default CommissionBlock;
